/**
 * RDV-13: bloco verde do topo, só com as pílulas de contagem do ciclo (`pilulasDoCiclo`). Sem total, gráfico nem
 * texto de pontos (AD-034). Sem as pílulas (`undefined`), o bloco guarda o lugar delas até todos os cartões
 * informarem a sua, para nenhuma aparecer depois das outras (RDV-42).
 */
export default function PilulasDoCiclo({ pilulas }: { pilulas?: string[] }) {
  return (
    <div className="mt-3.5 rounded-jj-2xl bg-brand-green px-7 py-5">
      {pilulas ? (
        <ul aria-label="Realizações do ciclo" className="m-0 flex list-none flex-wrap gap-2 p-0">
          {pilulas.map(pilula => (
            <li
              key={pilula}
              className="rounded-jj-pill bg-brand-white px-[13px] py-1.5 font-display text-xs font-bold text-brand-blue-dark"
            >
              {pilula}
            </li>
          ))}
        </ul>
      ) : (
        <div data-testid="pilulas-carregando" aria-hidden="true" className="flex flex-wrap gap-2">
          <span className="h-[27px] w-[150px] animate-pulse rounded-jj-pill bg-brand-white opacity-60" />
          <span className="h-[27px] w-[110px] animate-pulse rounded-jj-pill bg-brand-white opacity-60" />
        </div>
      )}
    </div>
  );
}
